<template lang="pug">
div.policy-stage(v-disabled="seeState")
  ul(style='display: flex;')
    li.Component-library1
    li.Component-library(ref="leftControl")
      div.scene-title
        span.span 场景选择
        li(v-for='item in sceneList',draggable="true")
          img(:src='item.src'
            draggable="true",
          @dragstart="dragstart(item.name)")
          span.name   {{item.name}}
      //- .show-box
        Poptip(content='只能在任务中添加题型')
          .show-title(style='height:300px') &nbsp;&nbsp;&nbsp;&nbsp;
      div.scene-title(:class="{'test-show' : canDrag}" title='只能在任务中添加题型')
        span.span 题型选择
        li.ti(v-for='(item,index) in QuestionList',
          :draggable="!canDrag",
          @dragstart="dragstart(item)")
            //- img(:src='questionSrc[index].src')
            Icon(:type="questionSrc[index].type",color='#3A76D2',size='22').icon
            span.name   {{item}}
      div.scene-title
        span.span 案例内容
        li.ti(v-for='(item,index) in caseList',draggable="true",
          @dragstart="dragstart(item)")
            //- img(:src='caseSrc[index].src')
            Icon(:type="caseSrc[index].type",color='#3A76D2',size='22').icon
            span.name   {{item}}
    li.tree-body
      div(v-if="!seeState" style="padding:20px 0 0 20px")
        Button(size="small" type="primary" ghost style="margin-right:10px" icon="md-add" @click="classVisible = true") 添加分类
        Button(size="small" type="primary" ghost style="margin-right:10px" icon="ios-create-outline" :disabled="stepIndex == 0" @click="handleEdit") 编辑
        Button(size="small" type="error" ghost style="margin-right:10px" icon="md-beaker" :disabled="stepIndex == 0" @click="handleRemoveClass") 删除
      Divider
      div(style="cursor:pointer;margin-left:20px" @click='goHome') 基本信息设置
      div
        RadioGroup(v-model="classVNode" vertical @on-change="onSelectChange")
          Radio(v-for="item in treeData" :key="item.id" :label="item.id")
            span {{ item.categoryName }}
      //- Tree.demo-tree-render(ref="treeDom" :data="treeData" @on-select-change="onSelectChange" title="categoryName")
    li.Formulate-content#Formulate-content(ref="Formulate-content")
      vueToTop(top='22',dom="Formulate-content")
      ul
        //- div.drag-position(v-if='dragState')
        li.task-list
          div.header(v-if="stepIndex != 0")
            //- Button(@click='goHome',style="width:116px;height:32px",:class="{'active':(stepIndex === 0)}") 基本信息设置
            //- ul.steps
            transition-group(name="flip-list",tag="ul").steps
              //- li.li(v-for='(item,index) in taskList',key='index',style='display: inline-block;')
              Tag.step(:closable="!seeState",v-for='(item,index) in taskList',:key="item.id",:class="{'active':stepIndex === index+1}",v-dragging="{ item: item, list: taskList, otherData: otherData}",@click.native='taskChange(index,item)', @on-close="deleteTask(index)")  {{item.name}}
              Button(icon="ios-add" type="primary" ghost size="small" @click="addTask",key="button",:disabled="seeState") 添加任务
            //- div.icon-right
            //-   Icon(type="md-add",@click='addTask',color='#3A76D2').add-task
          div.setting(v-if='stepIndex > 0')
            Form(label-position="right" :label-width="100")
              FormItem(label="任务名称")
                Input(v-model='taskName',:maxlength="10" placeholder="请输入任务名称")
              //- FormItem(label="任务提示")
              //-   Input(type="textarea",:maxlength="200",v-model="taskTip",placeholder="请输入任务提示")
              FormItem(label="任务通知")
                Input(type="textarea",:maxlength="25",placeholder="请输入任务通知" v-model="taskContent",:disabled="seeState")
              FormItem(label="任务详情")
                Input(v-model='taskNotify',:maxlength="200",placeholder="请输入任务详情")
            //- i.icon(@click='deleteTask')
            //-   Icon(type="ios-trash",size='18',color='#3A76D2')
        <!-- 引导语 !-->
          IndexHome(:assemblyName='assemblyName',v-if='stepIndex===0&&Refresh',ref='IndexHome',@delModel='deleteDepartment')
          IndexTask(v-for='(item,index) in taskList',
            :key='index',v-if='stepIndex!==0&&stepIndex===index+1&&Refresh',
            @nextStep='nextStep',
            :assemblyName='assemblyName',
            :selectDepartment='selectDepartment',
            :data='item',:ref='`task${index+1}`',
            :enableAI="enableAI",
            :haId="haId",
            :taId="taId"
            @refresh="refresh"
            @delModel='deleteDepartment'
            @handUpdate="handUpdate",
            @handUploadData="handUploadData"
            )
          // 首页大厅的确定按钮
        li.main-bottom(v-if='stepIndex===0')
          p 记得保存，记得保存，记得保存…重要的事情说三遍。
          button(type='button',@click='Sure', :disabled='isSaving||isPreserving')
            span(v-if="!isSaving&&!isPreserving") 保存
            span(v-else)
                i(class="fa fa-spinner fa-spin") 保存中...
          // 任务下的确定按钮
        li.main-bottom(v-if='stepIndex>0')
          p 记得保存，记得保存，记得保存…重要的事情说三遍。
          button(type='button',@click='taskSure') 确定
          //- button(type='button',@click='handUpdate(tableData)') 表格
  Modal(v-model='classVisible' :title="isEdit ? '修改分类' : '新增分类'" @on-ok="handleSubmitClass")
    Input(v-model="classTitle" placeholder="请输入分类标题" maxlength="20")
    p(style="color:red" v-if="classTitle.length === 20") 您最多可以输入20个字符
</template>
<script>
/* eslint-disable global-require */
import mybus from "@/utils/main";
import { intersectionBy, differenceBy, cloneDeep } from "lodash";
import { taskButton } from "../../../assets/js/case/taskDetermine.js";
import IndexHome from "../../../components/case/index.home"; // 基础信息设置
import IndexTask from "../../../components/case/index.task"; // 任务列表
import Bus from "../../../utils/bus";

export default {
  components: {
    IndexHome,
    IndexTask,
  },
  props: ["enableAI"],
  inject: ["seeState"],
  data() {
    return {
      goIndex: -1,
      toIndex: -1,
      show: true,
      Refresh: true,
      stageShow: "",
      stepIndex: 0, // 初始任务
      addTaskState: false, // 添加任务的按钮状态 false为可添加任务
      assemblyName: "",
      deleteDepartmentInt: [], // 删除部门的ID
      selectDepartment: "",
      taskList: [],
      leftScrollTop: "0",
      rightScrollTop: "0",
      taskName: "", // 任务名称
      taskContent: "", // 任务内容
      taskNotify: "",
      taskTip: "",
      classVisible: false,
      classTitle: "",
      treeData: [],
      classVNode: "",
      taId: "",
      sceneList: [
        // - { name: "首页大厅", src: require("../../../assets/case/case1.png") }, // eslint-disable-line global-require
        { name: "领导办公室", src: require("../../../assets/case/case2.png") }, // eslint-disable-line global-require
        { name: "我的办公室", src: require("../../../assets/case/case3.png") }, // eslint-disable-line global-require
        {
          name: "民意调查中心",
          src: require("../../../assets/case/case4.png"), // eslint-disable-line global-require
        },
        { name: "部门1", src: require("../../../assets/case/case5.png") }, // eslint-disable-line global-require
        { name: "会议室", src: require("../../../assets/case/metting.png") }, // eslint-disable-line global-require
        { name: "现场调研", src: require("../../../assets/case/survey.png") }, // eslint-disable-line global-require
        // { name: "会议室", src: require("../../../assets/case/case7.png") } // eslint-disable-line global-require
        // - { name: "部门2", src: require("../../../assets/case/case6.png") }, // eslint-disable-line global-require
        // - { name: "部门3", src: require("../../../assets/case/case7.png") }, // eslint-disable-line global-require
        // - { name: "部门4", src: require("../../../assets/case/case8.png") } // eslint-disable-line global-require
      ],
      /** 场景图-图库 */
      // - sceneList: [
      // -   { name: "部门1", src: require("../../../assets/case/case5.png") },
      // -   { name: "部门2", src: require("../../../assets/case/case6.png") },
      // -   { name: "部门3", src: require("../../../assets/case/case7.png") },
      // -   { name: "部门4", src: require("../../../assets/case/case8.png") },
      // -   { name: "部门5", src: require("../../../assets/case/case9.png") },
      // -   { name: "部门6", src: require("../../../assets/case/case10.png") },
      // -   { name: "部门7", src: require("../../../assets/case/case11.png") },
      // -   { name: "部门8", src: require("../../../assets/case/case12.png") },
      // -   { name: "部门9", src: require("../../../assets/case/case13.png") },
      // -   { name: "部门10", src: requi re("../../../assets/case/case14.png") },
      // -   { name: "部门11", src: require("../../../assets/case/case15.png") },
      // -   { name: "部门12", src: require("../../../assets/case/case16.png") },
      // -   { name: "部门13", src: require("../../../assets/case/case17.png") },
      // -   { name: "部门14", src: require("../../../assets/case/case18.png") },
      // -   { name: "部门15", src: require("../../../assets/case/case19.png") },
      // -   { name: "部门16", src: require("../../../assets/case/case20.png") },
      // -   { name: "部门17", src: require("../../../assets/case/case21.png") }
      // - ],
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      QuestionList: [
        "单选题",
        "多选题1",
        "多选题2",
        "填空题",
        "问答题",
        "选择填空题",
        "材料题",
        "表格题",
        "连线题",
        "改错题",
        // - "矩阵选择题"
      ],
      /* eslint-disable */
      questionSrc: [
        {
          src: require("../../../assets/case/subject/danxuan.png"),
          type: " iconfont icon-iconfontoptionbutton",
        },
        {
          src: require("../../../assets/case/subject/duoxuan.png"),
          type: " iconfont icon-duoxuan",
        },
        {
          src: require("../../../assets/case/subject/duoxuan2.png"),
          type: " iconfont icon-duoxuan",
        },
        {
          src: require("../../../assets/case/subject/tiankong.png"),
          type: " iconfont icon-tiankongti",
        },
        {
          src: require("../../../assets/case/subject/wenda.png"),
          type: " iconfont icon-wenda",
        },
        {
          src: require("../../../assets/case/subject/xuanzetiankong.png"),
          type: " iconfont icon-xuancitiankong",
        },
        {
          src: require("../../../assets/case/subject/juzhengxuanze.png"),
          type: " iconfont icon-cailiao",
        },
        {
          type: " iconfont icon-biaogeti",
        },
        {
          type: " iconfont icon-lianxianti",
        },
        {
          type: " iconfont icon-judge",
        },
        //- {
        //-   src: require("../../../assets/case/subject/juzhengxuanze.png"),
        //-   type: " iconfont icon-juzhenxuanze"
        //- }
      ],
      /* eslint-disable */
      caseList: [
        "案例引导语",
        // "消息通知",
        "文字——单文字",
        "文字——轴型",
        "人物对话",
        "文字图片",
        "视频文件",
        "标题",
        "小标题",
        "分割线",
        "提问-回答",
        "资料库",
        "部门文件",
        "附件",
      ],
      isEdit: false,
      caseSrc: [
        {
          src: require("../../../assets/case/subject/yingdao.png"),
          type: " iconfont icon-duihua",
        },
        // { src: require("../../../assets/case/subject/biaotiwenzi.png") },
        {
          src: require("../../../assets/case/subject/dan.png"),
          type: " iconfont icon-wenben",
        },
        {
          src: require("../../../assets/case/subject/wenzizhouxing.png"),
          type: " iconfont icon-wenben",
        },
        {
          src: require("../../../assets/case/subject/duihua.png"),
          type: " iconfont icon-duihua",
        },
        {
          src: require("../../../assets/case/subject/tuwen.png"),
          type: " iconfont icon-tupian",
        },
        {
          src: require("../../../assets/case/subject/shiping.png"),
          type: " iconfont icon-shipin",
        },
        {
          src: require("../../../assets/case/subject/title.png"),
          type: " iconfont icon-biaoti",
        },
        {
          src: require("../../../assets/case/subject/title.png"),
          type: " iconfont icon-biaoti",
        },
        {
          src: require("../../../assets/case/subject/divider.png"),
          type: " iconfont icon-fengexian",
        },
        {
          type: " iconfont icon--wendati",
        },
        {
          type: " iconfont icon-ziliaoguanli",
        },
        {
          type: " iconfont icon-wenjian1",
        },
        {
          type: " iconfont icon-kaoshi",
        },
      ],
      go: -1,
      tableData: [],
      uploadData: {},
      isSaving: false, // 防止重复提交
      isPreserving: false, // 控制 PreservationDepartment 重复提交
      selfIndex: -1,
      selfItem: {},
    };
  },
  beforeDestroy() {
    // ✅ 组件销毁前移除监听
    Bus.$off("refresh-task", this.refresh);
  },
  mounted() {
    // ✅ 监听事件
    Bus.$on("refresh-task", this.refresh);

    this.$dragging.$on("dragged", (value) => {
      this.go = this.taskList.findIndex((value2) => {
        return value2.id === value.draged.id;
      });

      //- this.stepIndex = go+1
    });
    this.getTaskTreeData();
    this.$dragging.$on("dragend", () => {
      const data = this.taskList.map((item, index) => {
        const data2 = {
          id: item.id,
          taskSequenceNumber: index,
        };
        return data2;
      });
      this.$http.batchUpdateTasks(data).then(async (res) => {
        console.log(res);
        await this.$parent.query();
        // this.stepIndex = 0;
        // this.classVNode = "";
      });
    });
  },
  methods: {
    async handleSubmitClass() {
      try {
        let params = {
          id: this.isEdit ? this.classVNode : undefined,
          pid: "0",
          chId: sessionStorage.getItem("chId"),
          categoryName: this.classTitle,
        };
        // await this.$http[this.isEdit ? "batchUpdateTaskOrCategory" : "createTaskCategory"]([
        //   params
        // ]);
        await this.$http[this.isEdit ? "batchUpdateTaskOrCategory" : "createTaskCategory"](params);
        this.getTaskTreeData();
        this.isEdit = false;
        this.classTitle = "";
        this.classVisible = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskTreeData() {
      try {
        const { data } = await this.$http.getCategoryAndTaskList(sessionStorage.getItem("chId"));
        this.treeData = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    handleEdit() {
      this.isEdit = true;
      this.classVisible = true;
    },
    handleRemoveClass(v) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>删除该分类后，将删除分类下所有的任务内容，确认要删除吗？</p>",
        onOk: async () => {
          try {
            await this.$http.removeTaskCategoryOrTask(
              this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
                .id,
              this.classVNode
            );
            this.goHome();
            this.getTaskTreeData();
            this.$Message.success("删除成功！");
          } catch (error) {
            console.log(error);
          }
        },
      });
    },
    onSelectChange(v) {
      // if (item.children) {
      //   return;
      // }
      // this.stepIndex = -1;
      this.classTitle = this.treeData.filter((item) => item.id == v)[0].categoryName;
      this.stepIndex = -1;
      this.taskList = [];
      // this.$parent.querylistTaskByChid(
      //   ,
      //   this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
      // );
      this.$parent
        .querylistTaskByChid(
          v,
          this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
        )
        .then((res) => {
          this.taskList = res.map((v) => {
            return {
              ...v,
              name: v.taskName,
            };
          });
        }) || []; // 添加任务完毕 查询添加完的列表
    },
    otherData() {},
    // handleClose(index) {
    //   //
    //   //
    //   // this.show = false;
    //   // const index = this.taskList.indexOf(name);
    //   // this.taskList.splice(index, 1);
    //   this.deleteTask();
    // },
    // handleAdd() {
    //   if (this.taskList.length) {
    //       this.addTask();
    //       this.taskList.push(this.taskList[this.taskList.length - 1] + 1);
    //   } else {
    //       this.taskList.push(0);
    //   }
    // },
    handUpdate(data) {
      this.tableData = data;
    },
    handUploadData(data) {
      this.uploadData = data;
    },
    taskSure() {
      let uploadData = this.$store.state.updateCase.updataData;
      if (
        !this.taskName ||
        !this.taskName.trim() ||
        !this.taskContent ||
        !this.taskContent.trim()
      ) {
        this.$refs["Formulate-content"].scrollTop = 0;
        this.$Message.error("请填写完整任务信息");
        return;
      }
      //- const currentTask = {};
      //- for (let item of Object.keys(this.$refs[`task${this.stepIndex}`][0].$refs)) {

      //- }
      //- console.log(currentTask,'currentTask');
      flag: for (let item of Object.keys(this.$refs[`task${this.stepIndex}`][0].$refs)) {
        const data = this.$refs[`task${this.stepIndex}`][0].$refs[item][0];
        console.log(data, data?.info, "dataaaaaaaa");
        console.log("🚀 ~ taskSure ~ data:", item);
        if (data === undefined || !!data?.info) {
          console.log("打断");
          break flag;
        }
        console.log("【data】");
        console.log(data);
        const info = data.info ? data.info : { departmentName: "其他" };
        if (info) {
          /** 说明是场景 先判断场景下的空填写完整与否 */
          //   debugger;
          switch (info.departmentName) {
            //不知道以前为什么需要for循环遍历这个funoffice，暂时换成跟我的办公室相同的逻辑
            case "领导办公室":
              if (!data.fun_office || data.fun_office.trim() === "") {
                data.$el.querySelectorAll("input")[0].focus();
                let rect = data.$el.getBoundingClientRect();
                //获取元素相对窗口的top值，此处应加上窗口本身的偏移
                let top = window.pageYOffset + rect.top;
                /** 距离顶部的控件高度 */
                const topH = 150;
                console.log(top);
                this.$refs["Formulate-content"].scrollTop += top - topH;
                this.$Message.error("请填写完整");
                return;
              }
              break;
            case "我的办公室":
              if (!data.fun_office || data.fun_office.trim() === "") {
                data.$el.querySelectorAll("input")[0].focus();
                let rect = data.$el.getBoundingClientRect();
                //获取元素相对窗口的top值，此处应加上窗口本身的偏移
                let top = window.pageYOffset + rect.top;
                /** 距离顶部的控件高度 */
                const topH = 150;
                console.log(top);
                this.$refs["Formulate-content"].scrollTop += top - topH;
                this.$Message.error("请填写完整");
                return;
              }
              break;
            case "民意调查中心":
              if (this.getObjectEmpty(data.form)) {
                data.$el.querySelectorAll("input")[0].focus();
                let rect = data.$el.getBoundingClientRect();
                //获取元素相对窗口的top值，此处应加上窗口本身的偏移
                let top = window.pageYOffset + rect.top;
                /** 距离顶部的控件高度 */
                const topH = 150;
                console.log(top);
                this.$refs["Formulate-content"].scrollTop += top - topH;
                this.$Message.error("请填写完整");
                return;
              }
              break;
            default:
              console.log(data.form, "data.form");
              if (!data.form?.departmentName) {
                let rect = data.$el.getBoundingClientRect();
                //获取元素相对窗口的top值，此处应加上窗口本身的偏移
                let top = window.pageYOffset + rect.top;
                /** 距离顶部的控件高度 */
                const topH = 150;
                console.log(top);
                this.$refs["Formulate-content"].scrollTop += top - topH;
                this.$Message.warning("请到任务下添加场景");
                return;
              }
              break;
          }
        }
        for (let i in data.$refs) {
          console.log(data.$refs[i][0], "data.$refs[i][0].question");
          console.log(data.$refs.question, "data.$refs[i][0].question");
          console.log(
            this.getObjectEmpty(data.$refs.question),
            "this.getObjectEmpty(data.$refs[i][0].question)"
          );

          if (
            data.$refs[i][0] &&
            data.$refs?.question &&
            this.getObjectEmpty(data.$refs?.question)
          ) {
            try {
              data.$refs[i][0].$el.querySelectorAll("input")[0].focus();
            } catch (err) {
              data.$refs[i][0].$el.querySelectorAll("textarea")[0].focus();
            }

            let rect = data.$refs[i][0].$el.getBoundingClientRect();
            //获取元素相对窗口的top值，此处应加上窗口本身的偏移
            let top = window.pageYOffset + rect.top;
            /** 距离顶部的控件高度 */
            const topH = 100;
            console.log(top);
            console.dir(this.$refs["Formulate-content"].scrollHeight);
            this.$refs["Formulate-content"].scrollTop += top - topH;
            console.log(data.$refs[i][0], "data.$refs[i][0]");
            this.$Message.error("请填写完整");
            return;
          }
        }
      }
      this.PreservationTask();
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18,
              },
            }),
            h("div", "正在保存数据中...."),
          ]);
        },
      });
      /** 任务列表下的确定按钮 */
      /** index 任务的序号 */
      /** scene 当前任务的实例 */
      /** taId -> 当前任务的id */
      //

      const taId = this.taskList[this.stepIndex - 1].id;
      const index = this.stepIndex - 1;
      const scene = this.$refs[`task${this.stepIndex}`][0];
      console.log(scene, "scenescenescene");
      //
      taskButton(
        index,
        scene,
        taId,
        this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
      )
        .then((res) => {
          console.log("taskButtonres", res);
          //
          this.$http
            .batchDeletingTaskScenario({
              ids: JSON.stringify(this.deleteDepartmentInt),
            })
            .then((ele) => {
              //
              /** 先调用删除函数 删除成功再调用添加或修改 */
              this.$http.AddOrUpdateTaskScenario({ list: res }).then((res3) => {
                console.log("🚀 ~ this.$http.AddOrUpdateTaskScenario ~ res3:", res3);
                res3.data.data.forEach((data3, index99) => {
                  // 取值
                  let DU =
                    this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]
                      .assemblyList;
                  console.log(
                    "🚀 ~ res3.data.data.forEach ~ this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]:",
                    this.$refs[`task${this.stepIndex}`][0],
                    this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0],
                    this.$refs[`task${this.stepIndex}`][0]
                  );
                  let isUnitAScene = scene.assemblyList.find((item) => item.name == "UnitA");
                  let table = DU.find((item) => item.name == "TableQuestion");
                  console.log(
                    "🚀 ~ file: policyStage.vue:592 ~ res3.data.data.forEach ~ this.scene:",
                    scene
                  );
                  if (table && !isUnitAScene) {
                    table.data = this.tableData;
                  }
                  let caseUpload = DU.find((item) => item.name == "CaseUpload");
                  // 避免直接使用不存在的变量导致undefined，进而导致无法提交
                  if (uploadData && caseUpload) {
                    if (caseUpload.name === "CaseUpload") {
                      let upload = DU.find(
                        (item) => item.data?.id === uploadData.id && item.name === "CaseUpload"
                      );
                      if (upload) {
                        upload.data = uploadData;
                      }
                    }
                  }

                  console.log(DU, "DU");

                  if (data3.departmentName == "现场调研" || data3.departmentName == "会议室") {
                    sessionStorage.setItem("isCZJL", true);
                    if (data3.functionName == "MultipleA") {
                      DU = [
                        {
                          name: "MultipleA",
                          data: this.$refs[`task${this.stepIndex}`][0].$refs[
                            `taskIndex${index99}`
                          ][0].$refs["MultipleA0"][0].question,
                        },
                      ];
                    }
                  } else {
                    sessionStorage.setItem("isCZJL", false);
                  }
                  /**   每个场景下面的所有控件 DU-> this.$refs[`task${this.stepIndex}`][0].$refs[ `taskIndex${index99}`][0].assemblyList */
                  console.log(DU, "DU");
                  this.MX_Handle(DU, data3.id, index99);
                  // 创建控件接口 需要传一个全部控件列表 / 传一个场景的ID  this.MX_Handle()
                });
                mybus.$emit("editDepartment", res3.data.data);
              });
            });
        })
        .catch((error) => {
          console.log(error);
          this.$Message.error("请填写完整部门场景!");
        });
      sessionStorage.setItem("isDisabled", false);
    },
    taskSure1() {
      // 返回时保存
      this.PreservationTask();
      /** 任务列表下的确定按钮 */
      /** index 任务的序号 */
      /** scene 当前任务的实例 */
      /** taId -> 当前任务的id */
      //

      const taId = this.taskList[this.stepIndex - 1].id;
      const index = this.stepIndex - 1;
      const scene = this.$refs[`task${this.stepIndex}`][0];

      taskButton(
        index,
        scene,
        taId,
        this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
      )
        .then((res) => {
          //
          this.$http
            .batchDeletingTaskScenario({
              ids: JSON.stringify(this.deleteDepartmentInt),
            })
            .then((ele) => {
              //
              /** 先调用删除函数 删除成功再调用添加或修改 */
              this.$http.AddOrUpdateTaskScenario({ list: res }).then((res3) => {
                res3.data.data.forEach((data3, index99) => {
                  /**   每个场景下面的所有控件 DU-> this.$refs[`task${this.stepIndex}`][0].$refs[ `taskIndex${index99}`][0].assemblyList */
                  console.log(
                    "list",
                    this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]
                  );
                  const DU =
                    this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]
                      .assemblyList;
                  console.log(
                    "🚀 ~ res3.data.data.forEach ~ this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]:",
                    this.$refs[`task${this.stepIndex}`][0].$refs[`taskIndex${index99}`][0]
                  );

                  this.MX_Handle(DU, data3.id, index99);
                  // 创建控件接口 需要传一个全部控件列表 / 传一个场景的ID  this.MX_Handle()
                });
                mybus.$emit("editDepartment", res3.data.data);
                this.$role.role === "student"
                  ? this.$router.push("/Student/custom-case")
                  : this.$router.push("/Teacher/case");
              });
            });
        })
        .catch((error) => {
          console.log(error);
          this.$Message.error("请填写完整部门场景!");
        });
    },
    deleteDepartment(idx) {
      // 删除部门函数
      this.deleteDepartmentInt.push(idx); // 删除的部门ID
    },
    goHome() {
      // 返回创建大厅场景
      this.stepIndex = 0;
      this.classVNode = "";
    },
    async refresh() {
      console.log("啵啵啵啵啵啵", this.selfIndex);
      if (this.selfIndex === -1) {
        return;
      }
      this.taskChange(this.selfIndex, this.selfItem);
    },
    async taskChange(index, item) {
      (this.selfIndex = index), (this.selfItem = item), console.log("啊啊啊", index, item);
      await this.$parent.query();
      if (item) {
        console.log(item, "iteitenindasdo");
        this.$store.commit("setTaskInfo", item);
        sessionStorage.setItem("taskInfo", JSON.stringify(item));
      }
      sessionStorage.setItem("isDisabled", false);
      this.getTaskById(index);
      //
      // 切换任务 查询任务下的场景
      const data = {
        taId: this.taskList[index].id,
      };
      this.taId = this.taskList[index].id;
      this.$http.listTaskScenarioByTaid(data).then(async (res) => {
        const data1 = {
          index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
          SceneList: res.data.data,
          setIndex: index,
        };
        this.$store.commit("postTaskScene", data1);
        const data2 = JSON.parse(JSON.stringify(data1));
        this.$store.commit("postTaskScene1", data2);
        await this.$store.commit("emptyDeleteControlList"); // 切换任务之后 清空掉要删除掉的控件ID
        this.stepIndex = index + 1;
        this.$store.commit("setModules", "");
        for (let i = 0; i < res.data.data.length; i++) {
          const element = res.data.data[i];
          // if (
          //   res.data.data[i].departmentName != "会议室" &&
          //   res.data.data[i].departmentName != "现场调研"
          // ) {

          // }
          console.log(data1, "data1");
          await this.queryControl(element.id, i, index, item);
        }
        //- res.data.data.forEach((element, index1) => {
        //-   this.queryControl(element.id, index1, index);
        //-   // console.log(res);
        //- });
        mybus.$emit("editDepartment", res.data.data);
        this.$parent.setScrollHeight();
      });
    },
    nextStep(index) {
      this.$nextTick(() => {
        this.taskName = this.$refs[`task${this.stepIndex}`][0].data.name;
      });
    },
    PreservationTask() {
      // 保存任务基本信息
      const data = {
        chId: this.taskList[this.stepIndex - 1].chId,
        id: this.taskList[this.stepIndex - 1].id,
        taskName: this.taskName,
        taskContent: this.taskContent,
        taskTip: this.taskTip,
        taskNotify: this.taskNotify,
        taskSequenceNumber: this.stepIndex - 1,
      };
      this.$http.AddOrUpdateTask({ list: [data] }).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          this.$Spin.hide();
          let data1 = {
            index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
            taskIndex: this.stepIndex - 1,
            taskName: this.taskName,
            // taskContent: this.taskContent,
          };
          this.taskList[this.stepIndex - 1].name = this.taskName;
          this.$store.commit("postTaskTitle", data1);
          // this.$parent.querylistTaskByChid(
          //   this.parent.Case.caseData[
          //     this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
          //   ].id
          // ); // 保存任务完毕 查询添加完的列表
        }
      });
    },
    getTaskById(index) {
      //
      const data = {
        id: this.taskList[index].id,
      };
      this.$http.getTaskById(data).then((res) => {
        if (res.data.success) {
          this.taskContent = res.data.data.taskContent;
          this.taskName = res.data.data.taskName;
          this.taskNotify = res.data.data.taskNotify;
          this.taskTip = res.data.data.taskTip;
        }
      });
    },
    deleteTask(index) {
      // 删除任务
      this.$Modal.confirm({
        title: "删除",
        content: `<p>是否删除该任务内容？删除后数据不可恢复！</p>`,
        onOk: () => {
          const data = {
            ids: JSON.stringify([this.taskList[index].id]),
          };
          this.$http.removeTask(data).then((res) => {
            if (res.data.success) {
              this.taskList.splice(index, 1);
              this.$parent
                .querylistTaskByChid(
                  this.classVNode,
                  this.parent.Case.caseData[
                    this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
                  ].id
                )
                .then((res) => {
                  this.taskList = res.map((v) => {
                    return {
                      ...v,
                      name: v.taskName,
                    };
                  });
                }) || []; // 添加任务完毕 查询添加完的列表
              this.$Message.success("已删除");
              this.stepIndex = -1;
            }
          });
        },
      });
    },
    /** 废弃代码------暂 */
    /** 2019/6/12更新 未废弃函数 用来保存大厅下的部门 */

    async PreservationDepartment() {
      if (this.isPreserving) return;
      this.isPreserving = true;
      try {
        // 获取当前阶段的索引
        const caseStageIndex = +sessionStorage.getItem("CaseStage") - 1;
        if (
          isNaN(caseStageIndex) ||
          caseStageIndex < 0 ||
          caseStageIndex >= this.caseValue.length
        ) {
          console.error("Invalid CaseStage index");
          return;
        }

        const currentCaseIndex = this.caseValue[caseStageIndex];
        const currentCaseData = this.parent.Case.caseData[currentCaseIndex];
        let incrementI = false;
        console.log(
          "🚀 ~ file: policyStage.vue:894 ~ hallListSimple ~ this.$refs.IndexHome.hallList:",
          this.$refs.IndexHome.hallList,
          currentCaseData.taskHome
        );
        const tempHL = cloneDeep(this.$refs.IndexHome.hallList);
        const tempCCD = cloneDeep(currentCaseData.taskHome);
        const hallListSimple = this.$refs.IndexHome.hallList.map((e, i) => {
          console.log("🚀 ~ file: policyStage.vue:896 ~ hallListSimple ~ serialNumberMax:", tempHL);
          const isHLHaveSerialNumber = tempHL.every((item) => {
            return item?.serialNumber ?? false;
          });
          const isEmptyRemote = !tempCCD.length;
          console.log(
            "🚀 ~ file: policyStage.vue:871 ~ isHLHaveSerialNumber ~ isHLHaveSerialNumber:",
            tempCCD,
            isEmptyRemote
          );

          let serialNumberMax = isEmptyRemote
            ? 4
            : tempCCD.sort((a, b) => b.serialNumber - a.serialNumber)[0].serialNumber;

          console.log(
            "🚀 ~ file: policyStage.vue:896 ~ hallListSimple ~ serialNumberMax:",
            serialNumberMax,
            tempHL
          );
          const ires = () => {
            incrementI = true;
            return 1;
          };
          console.log(
            "🚀 ~ file: policyStage.vue:893 ~ hallListSimple ~ e,i:",
            e,
            i,
            !!e.id ? (incrementI ? i++ : i) : i + ires(),
            !!e.id,
            incrementI,
            i,
            ires()
          );
          return {
            departmentName: e.name,
            serialNumber: !!e.id ? i++ : serialNumberMax + 1,
            id: e.id,
            chId: currentCaseData.id,
          };
        });
        console.log(
          "🚀 ~ file: policyStage.vue:894 ~ hallListSimple ~ hallListSimple:",
          hallListSimple,
          CCDTSimple
        );
        const CCDTSimple = currentCaseData.taskHome;
        const idNameCommonEle = hallListSimple.filter((v) => {
          return CCDTSimple.some((v2) => {
            if (!!v.id && v2.id === v.id && v2.departmentName === v.departmentName) {
              return true;
            } else {
              return false;
            }
          });
        });

        const idCommonEle = hallListSimple.filter((v) => {
          return CCDTSimple.some((v2) => {
            if (!!v.id && v2.id === v.id) {
              console.log(
                "🚀 ~ file: policyStage.vue:923 ~ returnCCDTSimple.some ~ v2.id:",
                v2.id,
                v.id
              );
              return true;
            } else {
              return false;
            }
          });
        });
        const idSameName = hallListSimple.filter((v) => {
          return CCDTSimple.some((v2) => {
            if (v2.departmentName === v.departmentName) {
              return true;
            } else {
              return false;
            }
          });
        });
        const insertEle = hallListSimple.filter((v) => {
          console.log(
            "🚀 ~ file: policyStage.vue:913 ~ idCommonEle ~ idCommonEle:",
            idSameName.some((v2) => v2.departmentName === v.departmentName),
            idSameName
          );
          return !v.id && !idSameName.some((v2) => v2.departmentName === v.departmentName);
        });

        const modifyEle = differenceBy(idCommonEle, idNameCommonEle, "id");
        console.log(
          "🚀 ~ file: policyStage.vue:946 ~ PreservationDepartment ~ idCommonEle, idNameCommonEle:",
          idCommonEle,
          idNameCommonEle
        );
        const localServerJudge = () => {
          if (!!insertEle.length && !!modifyEle.length) {
            return (
              !!intersectionBy(CCDTSimple, insertEle, "departmentName").length ||
              !!intersectionBy(CCDTSimple, modifyEle, "departmentName").length
            );
          } else {
            return false;
          }
        };
        const sameNameJudge = () => {
          const res = hallListSimple.filter((v) => {
            const num = hallListSimple.filter((v2) => {
              console.log("🚀 ~ file: policyStage.vue:958 ~ res ~ v2:", v2, v);
              return v2.departmentName === v.departmentName;
            }).length;
            console.log("🚀 ~ file: policyStage.vue:957 ~ num ~ num:", num);
            return num > 1;
          }).length;
          console.log("🚀 ~ file: policyStage.vue:956 ~ res ~ res:", res);
          return !!res;
        };
        console.log(
          "🚀 ~ file: policyStage.vue:931 ~ PreservationDepartment ~ localServerJudge:",
          localServerJudge(),
          intersectionBy(CCDTSimple, insertEle, "departmentName"),
          intersectionBy(CCDTSimple, modifyEle, "departmentName"),
          insertEle,
          modifyEle,
          CCDTSimple
        );
        console.log(localServerJudge(), sameNameJudge());
        if (localServerJudge() || sameNameJudge()) {
          this.$Spin.hide();
          this.isPreserving = false;
          return this.$Message.error("部门名不能重复");
        }
        if (currentCaseData.taskHome.length === 0) {
          // 第一次创建数据
          const data = this.$refs.IndexHome.hallList.map((element, index) => ({
            departmentName: element.name,
            chId: currentCaseData.id,
            serialNumber: index,
            id: element.id,
          }));

          try {
            const res = await this.$http.createOrUpdateCaseDepartmentStep({ list: data });
            if (res.data.success) {
              // 可选：你可以在这里也提交 Vuex 更新
              // const data2 = {
              //   index: currentCaseIndex,
              //   taskHome: data,
              // };
              // this.$store.commit("postcaseHome", data2);

              await this.$parent.query(currentCaseData.id);
            } else {
              this.$Message.error("保存失败");
            }
          } catch (error) {
            console.error("Error creating or updating case department step:", error);
          } finally {
            this.isPreserving = false;
          }
        } else {
          // 否则为修改数据
          // const deleteIds = [];
          const editData = [];
          // currentCaseData.taskHome 原数据
          //this.$refs.IndexHome.hallList 用户实际修改数据
          // 归一化

          console.log(
            "🚀 ~ file: policyStage.vue:924 ~ PreservationDepartment ~ modifyEle:",
            modifyEle
          );
          console.log(
            "🚀 ~ file: policyStage.vue:926 ~ PreservationDepartment ~ insertEle:",
            insertEle
          );
          console.log(
            "🚀 ~ file: policyStage.vue:887 ~ DArr ~ currentCaseData.taskHome:",
            currentCaseData.taskHome,
            this.$refs.IndexHome.hallList
          );
          editData.push(
            ...[...modifyEle, ...insertEle].sort((a, b) => a.serialNumber - b.serialNumber)
          );
          console.log(
            "🚀 ~ file: policyStage.vue:935 ~ PreservationDepartment ~ editData:",
            editData
          );
          // let cantMatch = null;
          // for (let j = 0; j < this.$refs.IndexHome.hallList.length; j++) {
          //   // 用户实际修改只有name和id
          //   const userEditElement = this.$refs.IndexHome.hallList[j];
          //   console.log("🚀 ~ file: policyStage.vue:898 ~ PreservationDepartment ~ j:", j,currentCaseData.taskHome.length);
          //   if (j < currentCaseData.taskHome.length) {
          //     for (let index = 0; index < currentCaseData.taskHome.length; index++) {
          //       // 原始数据最全
          //       const originElement = currentCaseData.taskHome[index];
          //       console.log(
          //         "🚀 ~ file: policyStage.vue:901 ~ PreservationDepartment ~ userEditElement:",
          //         userEditElement
          //       );

          //       if (userEditElement.name !== originElement.departmentName) {
          //         if (userEditElement.id === originElement.id) {

          //             console.log("条件A", editData);
          //             // 修改名称
          //             editData.push({
          //               id: userEditElement.id,
          //               departmentName: userEditElement.name,
          //               serialNumber: index,
          //               chId: currentCaseData.id,
          //             });
          //             // return;

          //         } else {
          //           console.log(
          //             "🚀 ~ file: policyStage.vue:916 ~ PreservationDepartment ~ index:",
          //             currentCaseData.taskHome,
          //             index,
          //             this.$refs.IndexHome.hallList,
          //             j,
          //             userEditElement
          //           );
          //           // 这里有问题不能这样判断，会导致压入数组的数据不准确
          //           if (j ===this.$refs.IndexHome.hallList.length-1) {
          //             cantMatch = userEditElement;
          //           }
          //         }
          //       }
          //     }
          //     if (!!cantMatch) {
          //       editData.push({
          //         departmentName: cantMatch.name,
          //         serialNumber: j,
          //         chId: currentCaseData.id,
          //       });
          //       cantMatch = null;
          //     }
          //   } else {
          //     editData.push({
          //       departmentName: userEditElement.name,
          //       serialNumber: j,
          //       chId: currentCaseData.id,
          //     });
          //   }
          // }
          // this.$refs.IndexHome.hallList.forEach((element, index) => {
          //   if (index < currentCaseData.taskHome.length) {
          //     const existingDepartment = currentCaseData.taskHome[index];
          //     if (element.name !== existingDepartment.departmentName) {
          //       if (element.id === existingDepartment.id) {
          //         // 修改名称
          //         editData.push({
          //           id: existingDepartment.id,
          //           departmentName: element.name,
          //           serialNumber: index,
          //           chId: currentCaseData.id,
          //         });
          //       } else {
          //         // 添加新部门
          //         editData.push({
          //           departmentName: element.name,
          //           serialNumber: index,
          //           chId: currentCaseData.id,
          //         });
          //         // deleteIds.push(existingDepartment.id); // 注释掉的代码
          //       }
          //     }
          //   } else {
          //     // 新建部门
          //     editData.push({
          //       departmentName: element.name,
          //       serialNumber: index,
          //       chId: currentCaseData.id,
          //     });
          //   }
          // });

          //   const list222 = Array.isArray(hallListSimple.list) ? hallListSimple.list : hallListSimple;

          //   list222.forEach((item, index) => {
          //     item.serialNumber = index;
          //   });

          try {
            //new已改为组件内删除
            // // 计算要删除的 ID
            // const sameNameDelArr = intersectionBy(CCDTSimple, hallListSimple, "departmentName");
            // const userDataArr = differenceBy(hallListSimple, sameNameDelArr, "departmentName");
            // const remoteDataArr = differenceBy(CCDTSimple, sameNameDelArr, "departmentName");
            // const deleteIds = differenceBy(remoteDataArr, userDataArr, "id").map((item) => item.id);
            // console.log("🚀 ~ 删除ID计算结果:", {
            //   sameNameDelArr,
            //   userDataArr,
            //   remoteDataArr,
            //   deleteIds,
            // });
            // if (deleteIds.length > 0) {
            //   // 删除旧的部门
            //   await this.$http.batchDeletingCaseDepartmentStep({ ids: JSON.stringify(deleteIds) });
            // }
            // 保存部门
            const saveList = cloneDeep(
              this.$refs.IndexHome.hallList.map((item, index) => {
                return {
                  departmentName: item.name,
                  id: item.id,
                  chId: currentCaseData.id,
                  serialNumber: index,
                };
              })
            );
            const res = await this.$http.createOrUpdateCaseDepartmentStep({
              list: saveList,
            });

            // 查询更新后的数据
            await this.$parent.query(currentCaseData.id);

            // 提示成功
            this.$Message.success("部门保存成功！");
          } catch (error) {
            console.error("保存或删除部门失败:", error);
          } finally {
            this.isPreserving = false;
          }
        }
      } catch (e) {
        console.error("PreservationDepartment error:", e);
        this.$Message.error("保存部门信息失败");
        this.isPreserving = false;
      } finally {
        // this.isPreserving = false;
      }
    },
    queryControl(id, index, setindex, item) {
      return new Promise(async (resolve) => {
        // 查询场景下的控件
        // console.log(data);
        // console.log(this);
        setTimeout(() => {
          const data = {
            tsId: id,
            module: this.$store.state.task.modules,
          };
          console.log(this.$store.state.task.modules, "这里执行4444");
          this.$http.listControlByTsid(data).then(async (res) => {
            let infoData1 = [];
            if (item) {
              const { data: infoData } = await this.$http.listMaterials(item.id);
              infoData1 = infoData;
            }
            let data2 = {
              index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
              data: res.data.data,
              setIndex: setindex,
              sceneIndex: index,
            };
            // this.ObtainSubject(res.data.data.concat(infoData1.data.ZLK || []));
            this.$store.commit("postSceneControl", data2);
            console.log("这里执行3");
            if (
              res.data.data.some(
                (v) => v.stem.indexOf("会议室") != -1 || v.stem.indexOf("现场调研") != -1
              )
            ) {
              return;
            } else {
              console.log(res.data.data.concat(infoData1.data));
              mybus.$emit(`add${index}`, res.data.data.concat(infoData1.data || []));
            }
            resolve();
          });
        }, 500);
      });
    },
    /** 判断对象值是否有空 */
    getObjectEmpty(data) {
      console.log("🚀 ~ getObjectEmpty ~ data:", data);
      let value = false;
      /** arr => 不检测哪些字段 */
      const arr = [
        "tips",
        "tip",
        "extraQuestionsList",
        "logic",
        "image",
        "answer",
        "scoringKeywords",
        "children",
        "file",
        "url",
      ];
      for (const key in data) {
        //- debugger;
        if (arr.indexOf(key) === -1) {
          if (
            (data[key] === "" || data[key] === null || data[key] === undefined) &&
            arr.indexOf(key) === -1
          ) {
            return (value = true);
          } else if (Array.isArray(data[key])) {
            if (data[key].length === 0) {
              return (value = true);
            } else if (key === "metas") {
              for (let i = 0; i < data[key].length; i++) {
                if (this.getObjectEmpty(data[key][i])) {
                  return true;
                }
              }
            }
          }
        }
      }
      return value;
    },
    /** 保存首页大厅下面的控件 */
    async Sure() {
      if (this.isSaving) return; // 避免重复提交
      this.isSaving = true;

      try {
        if (!this.$refs.IndexHome._data.stageShow) {
          this.$Message.error("请填写案例阶段说明");
          return;
        }

        for (let item of Object.keys(this.$refs.IndexHome.$refs)) {
          const data = this.$refs.IndexHome.$refs[item][0];
          if (data && data.question && this.getObjectEmpty(data.question)) {
            data.$el.querySelectorAll("input")[0].focus();
            const rect = data.$el.getBoundingClientRect();
            const top = window.pageYOffset + rect.top;
            this.$refs["Formulate-content"].scrollTop += top - 250;
            this.$Message.error("请填写完整");
            return;
          }
        }

        this.$Spin.show({
          render: (h) =>
            h("div", [
              h("Icon", {
                class: "demo-spin-icon-load",
                props: { type: "ios-loading", size: 18 },
              }),
              h("div", "正在保存数据中..."),
            ]),
        });

        switch (this.stepIndex) {
          case 0:
            const halllist = this.$refs.IndexHome.hallList.map((ele) => ele.name);

            if (this.haveRepeatEle) {
              this.$Message.error("部门名不能重复");
              return;
            }

            if (
              !halllist.includes("我的办公室") ||
              !halllist.includes("领导办公室") ||
              !halllist.includes("民意调查中心")
            ) {
              this.$Message.error("必须包含我的办公室，领导办公室，民意调查这三个部门");
              this.isrepeat = true;
              return;
            }

            const stepIndex = +sessionStorage.getItem("CaseStage") - 1;
            const caseId = this.parent.Case.caseData[this.caseValue[stepIndex]].id || "";

            const payload = {
              background: "FRONTHALL",
              caseStep: this.caseValue[stepIndex],
              id: caseId,
              pyId: this.parent.Case.basic.id,
              stageShow: this.$refs.IndexHome.stageShow,
            };

            const res = await this.$http.createOrUpdateCaseHall(payload);

            if (res.data.success) {
              if (!res.data.data) {
                this.parent.Case.caseData[this.caseValue[stepIndex]].taskHome = [];
                this.parent.Case.caseData[this.caseValue[stepIndex]].id = "";
                this.$Message.success("保存成功！");
                return;
              }

              const resultData = {
                index: this.caseValue[stepIndex],
                id: res.data.data.id,
                stageShow: res.data.data.stageShow,
              };

              if (caseId === "") {
                this.$store.commit("postHallData", resultData);
              }

              await this.PreservationDepartment();
              this.$store.dispatch("updateCase/setAssemblyList", this.$refs.IndexHome.assemblyList);
              this.$store.dispatch("updateCase/setTsId", res.data.data.id);

              this.MX_Handle(this.$refs.IndexHome.assemblyList, res.data.data.id);

              //   this.$Message.success("保存成功！");
            }
            break;

          default:
            break;
        }
      } catch (error) {
        console.error("保存失败", error);
        this.$Message.error("保存失败，请重试");
      } finally {
        this.$Spin.hide();
        this.isSaving = false; // 结束时解锁
      }
    },

    async Sure1() {
      // 返回时保存
      const halllist = [];
      this.$refs.IndexHome.hallList.forEach((ele) => {
        halllist.push(ele.name);
      });
      const i1 = new Set(halllist);
      if ([...i1].length !== halllist.length) {
        return this.$Message.error("部门名不能重复");
      }
      if (
        halllist.indexOf("我的办公室") === -1 ||
        halllist.indexOf("领导办公室") === -1 ||
        halllist.indexOf("民意调查中心") === -1
        //  ||
        // halllist.indexOf("现场调研") === -1 ||
        // halllist.indexOf("会议室") === -1
      ) {
        this.$Message.error("必须包含我的办公室，领导办公室，民意调查这三个部门");
        this.isrepeat = true;
        return;
      }

      const data = await {
        background: "FRONTHALL",
        caseStep: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
        id: this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
          ? this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
          : "",
        pyId: this.parent.Case.basic.id,
        stageShow: this.$refs.IndexHome.stageShow,
      };
      console.log(data, "data222");
      this.$http.createOrUpdateCaseHall(data).then((res) => {
        if (res.data.success) {
          // this.$Message.success("保存成功");
          if (!res.data.data) {
            return;
          }
          let data = {
            index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
            id: res.data.data.id,
            stageShow: res.data.data.stageShow,
          };
          if (
            this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
              .id === ""
          ) {
            // 第一次保存 获取到大厅任务ID
            this.$store.commit("postHallData", data);
          }
          this.PreservationDepartment();
          /* sessionStorage.setItem('assemblyList',JSON.stringify(this.$refs.IndexHome.assemblyList));
            sessionStorage.setItem('tsId',JSON.stringify(this.parent.Case.caseData[
                this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
              ].id)) */
          this.$store.dispatch("updateCase/setAssemblyList", this.$refs.IndexHome.assemblyList);
          this.$store.dispatch(
            "updateCase/setTsId",
            this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
          );
          console.log(this.$refs.IndexHome.assemblyList);
          this.MX_Handle(
            this.$refs.IndexHome.assemblyList,
            this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
          ); // 传入一个全部控件列表
          this.$Message.success("保存成功");

          this.$role.role === "student"
            ? this.$router.push("/Student/custom-case")
            : this.$router.push("/Teacher/case");
        }
      });
    },
    addTask() {
      if (this.taskList.length == 20) {
        return this.$Message.error("任务不能超过20个！");
      }
      if (!this.addTaskState) {
        // 添加按钮状态 防止用户疯狂点击导致添加过多
        this.addTaskState = true;
        // 下面if判断 - 添加任务之前需添加部门 判断一下不然任务下添加场景报错
        if (
          this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
            .taskHome.length === 0
        ) {
          this.addTaskState = false;
          return this.$Message.error("添加任务之前请先完成基础信息设置！");
        }
        // 添加任务函数
        //需求取消校验
        // if (this.taskList.length >= 10) {
        //   this.addTaskState = false;
        //   return this.$Message.error("最多只能添加十个任务!");
        // }

        const data = {
          chId: sessionStorage.getItem("chId"),
          taskName: `任务${this.taskList.length + 1}`,
          taskCategoryId: this.classVNode,
          taskCategoryName: this.classTitle,
          taskSequenceNumber: this.taskList.length,
        };
        this.$http.AddOrUpdateTask({ list: [data] }).then((res) => {
          // this.taskList.push({ name: `任务${this.taskList.length + 1}` });
          this.$parent
            .querylistTaskByChid(
              this.classVNode,
              this.parent.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]].id
            )
            .then((res) => {
              this.taskList = res.map((v) => {
                return {
                  ...v,
                  name: v.taskName,
                };
              });
            }) || []; // 添加任务完毕 查询添加完的列表
          this.addTaskState = false;
        });
      }
    },
  },
  watch: {
    taskData() {
      this.taskList = this.taskData.map((res) => {
        return {
          name: res.taskName,
          id: res.id,
          taskSequenceNumber: res.taskSequenceNumber,
        };
      });
      console.log(this);
    },
    rightScrollTop: {
      handler(newVal) {
        if (this.seeState) {
          this.$refs["Formulate-content"].scrollTop = newVal;
        }
      },
    },
    leftScrollTop: {
      handler(newVal) {
        if (this.seeState) {
          this.$refs.leftControl.scrollTop = newVal;
        }
      },
    },
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    /** ↓ 该任务下的场景 */
    taskSceneList() {
      return;
    },
    dragState() {
      if (this.$refs[`task${this.stepIndex}`]) {
        return this.$refs[`task${this.stepIndex}`][0].dragState;
      } else {
        return true;
      }
    },
    parent() {
      return this.$parent;
    },
    sceneData() {
      // 保存的部门
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].task[this.stepIndex - 1].SceneList;
    },
    taskData() {
      // 所有任务
      console.log(
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .task
      );
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].task;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    depData() {
      return this.$store.state.task;
    },
    canDrag() {
      return this.stepIndex === 0 && this.Refresh;
    },
    haveRepeatEle() {
      const caseStageIndex = +sessionStorage.getItem("CaseStage") - 1;
      const currentCaseIndex = this.caseValue[caseStageIndex];
      const currentCaseData = this.parent.Case.caseData[currentCaseIndex];
      console.log("currentCaseData", currentCaseData);
      console.log(
        "currentCaseData.taskHome",
        currentCaseData?.taskHome,
        this.$refs.IndexHome.hallList
      );
      const simpleCCDArr = !!currentCaseData?.taskHome
        ? currentCaseData.taskHome.map((item) => {
            return { name: item.departmentName };
          })
        : [];
      const simpleHLArr = this.$refs.IndexHome.hallList.map((item) => {
        return { name: item.name };
      });
      const i1 = intersectionBy(simpleCCDArr, simpleHLArr, "name");
      const i2 = differenceBy(simpleHLArr, i1, "name");
      const i3 = intersectionBy(i2, i1, "name");
      console.log(
        "🚀 ~ file: policyStage.vue:1154 ~ Sure ~ i1:",
        i1,
        i2,
        i3,
        simpleCCDArr,
        simpleHLArr
      );
      console.log("🚀 ~ file: policyStage.vue:1154 ~ Sure ~ i1:", simpleCCDArr, simpleHLArr);
      return !!i3.length;
    },
  },
  created() {},
};
</script>

<style lang="stylus" socped>
.ivu-radio-input
  display none
.ivu-tree-title
  width 100%
  span
    position relative
.demo-tree-render
  width 100%
.policy-stage
  text-align left
  .Component-library1
    width 342px
    height calc(100vh - 65px)
    background #F8F9FA
    overflow auto
    box-shadow 0px 8px 12px -1px rgba(0, 0, 0, 0.3)
    display inline-block
  .tree-body
    min-width 300px
    background #fff
    margin 20px
    padding 10px
    border-radius 2px
  .Component-library
    position fixed
    width 342px
    height calc(100vh - 65px)
    background #F8F9FA
    overflow auto
    box-shadow 0px 8px 12px -1px rgba(0, 0, 0, 0.3)
    display inline-block
    .ti
      width 100%
      height 48px
      padding-top 0
      line-height 48px
      border 1px solid rgba(210, 221, 236, 1)
    li
      padding-top 16px
      text-align center
      img
        width 132px
        height 74px
        cursor move
      .name
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
        line-height 15px
    .scene-title
      display grid
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 0.8)
      line-height 20px
      padding 36px 24px 16px
      grid-template-columns 50% 50%
      grid-template-areas 'header header'
      justify-content center
      align-items center
      grid-row-gap 8px
      grid-column-gap 8px
      .span
        grid-area header
    .show-box
      width 100%
      hieght 2px
      background red
      position relative
      .show-title
        position absolute
        width 100%
        height 300px
        line-height 300px
        top 0px
        left 0px
        background green

  .model
    // border-bottom 1px solid #dddddd
  .Formulate-content
    height calc(100vh - 65px)
    display inline-block
    padding 24px 24px
    overflow auto
    flex 1
    .drag-position
      position fixed
      width 100%
      height 20px
      margin-top -20px
      background linear-gradient(0deg, #e0e0e0, #d8d8d8)
      min-width 854px
      max-width 1000px
    .task-list
      height auto
      // background rgba(255, 255, 255, 1)
      border-radius 4px
      // margin-bottom 20px
      margin-bottom 32px
      padding-top 32px
      padding-bottom 0
      padding-left 0
      min-width 854px
      max-width 1000px
      position relative
      z-index 6
      .setting
        margin-top 7px
        background rgba(255, 255, 255, 1)
        border-radius 4px
        min-width 854px
        max-width 1000px
        padding 32px
        .icon
          background rgba(242, 245, 250, 1)
          border-radius 4px
          padding 6px
          cursor pointer
          margin-left 8px
        input
          width 95%
          height 28px
          outline none
          padding 5px
          border-radius 4px
          border 1px solid rgba(210, 221, 236, 1)
        .Sure
          display inline-block
          margin-top -28px
          float right
          width 60px
          height 28px
          outline none
          cursor pointer
          background rgba(255, 255, 255, 1)
          border-radius 4px
          border 1px solid rgba(58, 118, 210, 1)
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(58, 118, 210, 1)
          line-height 18px
      .header
        display flex
        align-content center
        height auto
        // border-bottom 1px solid #ddd
        button
          &:hover
            border-color #dcdee2
            color #747b8b
        .active
          background rgba(58, 118, 210, 1) !important
          border-radius 4px !important
          border 1px solid rgba(210, 221, 236, 1) !important
          color #ffffff !important
          span
            color #ffffff !important
          i
            color #ffffff !important
        .add-task
          cursor pointer
        .steps
          width auto
          flex 1
          margin-left 10px
          .Horizontal-line
            width 46px
            background #ddd
            display inline-block
            padding-top 1px
            margin-bottom 4px
          .step
            min-width 106px
            height 30px
            font-size 14px
            line-height 30px
            margin 0
            margin-left 10px
            margin-right 10px
            cursor pointer
            background #FFFFFF
            margin-bottom 5px
            &:hover
              .ivu-icon
                width 15px
                transition 0.5s
            .ivu-icon
              font-size 20px
              width 0
              float right
              line-height 30px
              transition 0.5s
          .ivu-btn-ghost
            margin-left 10px
            height 32px
            font-size 14px
            background #FFFFFF
        .icon
          line-height 1rem
          padding 1rem
          font-size 1rem
        .icon-right
          background #f2f5fa
          font-size 1rem
          line-height 1rem
          border-radius 4px
          color #3A76D2
          height 24px
          width 24px
          text-align center
          margin-top 8px
          padding-top 3px
        .iconfont
          color #F5A623
    .Guide-language
      height 152px
      background rgba(255, 255, 255, 1)
      border-radius 4px
      padding 24px 32px
      min-width 854px
      max-width 1000px
      position relative
      .guide-content
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
        line-height 24px
        margin 28px 8px
      .surplus
        position absolute
        right 25px
        bottom 20px
        color #bdbcbc
    .title
      font-size 14px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 0.8)
      line-height 18px
    .main-content
      padding 24px 32px 60px 32px
      height auto
      background rgba(255, 255, 255, 1)
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.2)
      border-radius 4px
      margin-top 16px
      min-width 854px
      max-width 1000px
      .edit-department
        margin-top 30px
        padding 24px
        border-bottom 1px solid #dddddd
        .icon
          cursor pointer
        .role-name
          margin-left 8px
          padding 5px
          border none
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          line-height 18px
      .drag
        min-width 790px
        height 100px
        background #fff
        border-radius 4px
        border 1px dashed rgba(128, 128, 128, 0.5)
        margin-top 24px
        cursor alias
        p
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(128, 128, 128, 0.5)
          line-height 100px
          text-align center
      .case-back
        width 100%
        height 100%
        margin-top 22px
        margin-bottom 22px
        position relative
      .hallbackground
        height 35px
        position absolute
        background rgba(32, 120, 223, 1)
        box-shadow 0px 1px 6px 0px rgba(0, 0, 0, 0.23)
        border-radius 4px 4px 4px 0px
        min-width 35px
        border 1px solid rgba(255, 255, 255, 1)
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(255, 255, 255, 1)
        padding 6px
        cursor pointer
        text-align center
      .hall0
        left 50%
        top 51%
      .hall1
        left 62%
        top 26%
      .hall2
        left 12%
        top 33%
      .hall3
        left 61%
        top 62%
      .hall4
        left 48%
        top 17%
      .hall5
        left 24%
        top 48%
      .hall6
        left 12%
        top 66%
      .hall7
        left 31%
        top 17%
      .hall8
        left 75%
        top 63%
      .hall9
        left 43%
        top 69%
      .hall10
        left 39%
        top 29%
      .hall11
        left 89%
        top 44%
  .main-bottom
    min-width 854px
    max-width 1000px
    height 96px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    margin-top 16px
    text-align center
    padding-top 16px
    p
      font-size 12px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 24px
    button
      width 120px
      height 32px
      background rgba(58, 118, 210, 1)
      border-radius 4px
      border none
      outline none
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 0.8)
      line-height 18px
      margin-top 10px
      cursor pointer
@media screen and (min-width: 1560px) and (max-width: 2200px)
  .Component-library1
    width 475px!important
  .Component-library
    width 475px!important
    flex 0.3
    .scene-title
      grid-template-columns 30% 30% 30% !important
      grid-column-gap 3%
      grid-template-areas 'header header header' !important
    li
      img
        width 100% !important
        height 100% !important
.fa-spinner {
  margin-right: 5px;
}
.fa-spin {
  animation: fa-spin 1s infinite linear;
}
@keyframes fa-spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
</style>
